export default __webpack_public_path__ + "a4b9aa6452b8e9aca3f3ca345c100bb3.wav";